"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAGE_STATUSES = void 0;
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_2 = __importDefault(require("@tippyjs/react"));
const moment_1 = __importDefault(require("moment"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const get_1 = __importDefault(require("lodash/get"));
const react_redux_1 = require("react-redux");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const review_grid_constant_1 = require("../../../constants/review-grid-constant");
const helper_1 = require("../../../helper");
const review_stages_1 = require("../../../constants/review-stages");
const index_1 = require("../index");
const reviewSlice_1 = require("../../../../asset-detail/store/reviewSlice");
const selectors_1 = __importDefault(require("../../../../reviews-modal/slice/selectors"));
exports.STAGE_STATUSES = {
    in_progress: {
        value: 'in_progress',
        label: 'in progress',
    },
    not_started: {
        value: 'not_started',
        label: 'not started',
    },
    completed: {
        value: 'completed',
        label: 'completed',
    },
    view_only: {
        value: 'view_only',
        label: 'view only',
    },
    locked: {
        value: 'locked',
        label: 'locked',
    },
};
const stageTooltips = {
    stageStatus: 'Stage status',
    stageTrigger: 'Stage Trigger',
    stageDecisionRule: 'Stage Decision Rule',
    startStage: 'Start Stage',
    stageCog: 'Edit the Decision Rule, Deadline and Trigger for this stage',
};
const AccordionReviewStage = (props) => {
    var _a, _b, _c, _d;
    const { stage, stages, children, classes, isEdit, handleRemoveStage, onChange, handleChangeName, stageIndex, roundId, accordionReviewStageStatePath, setTriggerStateModal, } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const [reviewStage, setReviewStage] = (0, react_1.useState)(stage);
    const [deadlineColor, setDeadlineColor] = (0, react_1.useState)('');
    const ref = (0, react_1.useRef)(null);
    const stageStatus = stage.status;
    const { roundStages } = (0, react_redux_1.useSelector)(selectors_1.default);
    (0, react_1.useEffect)(() => {
        setReviewStage({ ...stage });
        const date = (stage === null || stage === void 0 ? void 0 : stage.deadline)
            ? (0, moment_1.default)(stage.deadline, 'YYYY-MM-DD h:mm:ss').format('MM/DD/YYYY')
            : undefined;
        const color = (0, helper_1.deadlineColorChange)(date);
        setDeadlineColor(color);
    }, [stage]);
    const getStageDecisionName = (0, react_1.useMemo)(() => {
        var _a;
        const stageStatusStrategyId = ((_a = stage === null || stage === void 0 ? void 0 : stage.stageStatusStrategy) === null || _a === void 0 ? void 0 : _a.statusStrategyId) ||
            (stage === null || stage === void 0 ? void 0 : stage.statusStrategyId);
        switch (stageStatusStrategyId === null || stageStatusStrategyId === void 0 ? void 0 : stageStatusStrategyId.toString()) {
            case '1':
                return 'All Users';
            case '2':
                return 'One User';
            case '3':
                return `Custom`;
            default:
                return 'All Users';
        }
    }, [(_a = stage === null || stage === void 0 ? void 0 : stage.stageStatusStrategy) === null || _a === void 0 ? void 0 : _a.statusStrategyId]);
    const handleOpenAcc = (event, isExpanded) => {
        if ((0, isFunction_1.default)(onChange)) {
            onChange(isExpanded);
        }
        setReviewStage({ ...reviewStage, isOpen: isExpanded });
        dispatch((0, reviewSlice_1.setAccordionReviewStageStatePath)({
            roundId,
            stageIndex,
            isOpen: isExpanded,
        }));
    };
    const handleChangeStageName = () => {
        var _a;
        const newName = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.innerText;
        const stageChange = {
            ...reviewStage,
            stageName: newName,
        };
        setReviewStage(stageChange);
        if (isEdit && (0, isFunction_1.default)(handleChangeName)) {
            handleChangeName(newName);
        }
    };
    const getTooltipDueDate = (0, react_1.useMemo)(() => {
        if (reviewStage.deadline) {
            const result = (0, moment_1.default)(reviewStage.deadline)
                .tz(helper_1.USER_TIMEZONE)
                .format('DD/MM/YYYY h:mm:ss a');
            return result;
        }
        return 'No deadline';
    }, [reviewStage.deadline]);
    const handleClickRemove = (e, id) => {
        e.stopPropagation();
        if ((0, isFunction_1.default)(handleRemoveStage)) {
            handleRemoveStage(id);
        }
    };
    const isExpanded = (0, get_1.default)(accordionReviewStageStatePath, [`round${roundId}`, `stage${stageIndex}`, 'isOpen'], (_b = reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.isOpen) !== null && _b !== void 0 ? _b : false);
    const allStages = roundStages !== null && roundStages !== void 0 ? roundStages : stages;
    const triggerType = (reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.triggerTypeId) || ((_c = reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.triggerType) === null || _c === void 0 ? void 0 : _c.id);
    const parentIndex = (0, react_1.useMemo)(() => {
        if (triggerType === helper_1.IMMEDIATELY || triggerType === helper_1.MANUALLY) {
            return -1;
        }
        const parentId = reviewStage.parentStageId;
        if (parentId) {
            return allStages === null || allStages === void 0 ? void 0 : allStages.findIndex((stg) => stg.clientId === parentId);
        }
        return -1;
    }, [allStages, triggerType, reviewStage]);
    const stageTriggerTypeName = (0, react_1.useMemo)(() => {
        switch (triggerType) {
            case helper_1.IMMEDIATELY:
                return 'Immediately';
            case helper_1.MANUALLY:
                return 'Manually';
            default: {
                const isExistIndex = parentIndex > -1;
                const previousIndex = stageIndex - 1;
                const displayParentIndex = isExistIndex ? parentIndex : previousIndex;
                return `S${displayParentIndex + 1} → S${stageIndex + 1}`;
            }
        }
    }, [triggerType, parentIndex, stageIndex]);
    // Only available in Review Detail
    const showPlayButton = (0, react_1.useMemo)(() => {
        var _a;
        const triggerTypeId = (_a = reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.triggerType) === null || _a === void 0 ? void 0 : _a.id;
        // Not IMMEDIATELY value
        const isManualOrWhen = triggerTypeId && triggerTypeId > helper_1.IMMEDIATELY;
        const isNotStarted = stageStatus === review_stages_1.STAGE_STATUS.notStarted;
        return isManualOrWhen && isNotStarted;
    }, [(_d = reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.triggerType) === null || _d === void 0 ? void 0 : _d.id, stageStatus]);
    const isShowTriggerStageButton = (0, react_1.useMemo)(() => {
        var _a;
        const inReviewStage = (_a = reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.members) === null || _a === void 0 ? void 0 : _a.find((member) => Number(utilities_1.USER.id) === Number(member.id));
        return (inReviewStage === null || inReviewStage === void 0 ? void 0 : inReviewStage.manage) || utilities_1.USER.reviewsAdmin;
    }, [reviewStage.members]);
    const handleTriggerStageManually = async (e) => {
        e.stopPropagation();
        if (!showPlayButton)
            return;
        await pulse_components_1.v2Endpoint
            .patch(`${utilities_1.URLS.app}api/round-stages/${reviewStage === null || reviewStage === void 0 ? void 0 : reviewStage.id}/start`, {})
            .then(() => {
            utilities_1.default.notification.success('Stage started successfully');
            dispatch((0, reviewSlice_1.fetchReviewRounds)({ roundId }));
            // reload grid events
            const reloadGridEvent = new CustomEvent('reload-review-grid', {
                detail: {
                    status: 200,
                },
            });
            document.dispatchEvent(reloadGridEvent);
        })
            .catch((err) => {
            utilities_1.default.notification.danger(err);
        });
    };
    return (react_1.default.createElement(pulse_components_1.PulseAccordion, { classes: {
            ...classes,
            root: (0, clsx_1.default)(styles_modules_less_1.default.accordion, classes === null || classes === void 0 ? void 0 : classes.root),
        }, slotProps: {
            transition: {
                unmountOnExit: true,
            },
        }, expanded: isExpanded, "data-testid": "stage-accordion" },
        react_1.default.createElement(pulse_components_1.PulseAccordionSummary, { expanded: isExpanded, classes: {
                root: styles_modules_less_1.default.summary__root,
                expandIconWrapper: styles_modules_less_1.default.summary__icon,
            } },
            react_1.default.createElement("div", null, reviewStage.isOpen ? (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-chevron-up', styles_modules_less_1.default['summary__expand-icon']), onClick: (e) => handleOpenAcc(e, false) })) : (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-chevron-down', styles_modules_less_1.default['summary__expand-icon']), onClick: (e) => handleOpenAcc(e, true) }))),
            react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.stageInfo, isEdit && styles_modules_less_1.default.stageInfoEdit) },
                react_1.default.createElement("span", null,
                    "S",
                    stageIndex + 1),
                "\u00A0",
                react_1.default.createElement(react_2.default, { content: reviewStage.name || reviewStage.nameStage, placement: 'top' },
                    react_1.default.createElement("div", { ref: ref, className: (0, clsx_1.default)(styles_modules_less_1.default.reviewStage, isEdit && styles_modules_less_1.default.reviewStageEditable, !isEdit && styles_modules_less_1.default.reviewStageDetail), contentEditable: isEdit, suppressContentEditableWarning: isEdit, onClick: (e) => e.stopPropagation(), onBlur: handleChangeStageName }, reviewStage.name || reviewStage.nameStage))),
            react_1.default.createElement(pulse_components_1.PulseStatusProgress, { view: (0, helper_1.getProgressSOCD)(reviewStage.progress, review_grid_constant_1.SOCD_VIEW.stage).view, progress: stageStatus !== review_stages_1.STAGE_STATUS.notStarted
                    ? (0, helper_1.getProgressSOCD)(reviewStage.progress, review_grid_constant_1.SOCD_VIEW.stage)
                        .progressStep
                    : index_1.DEFAULT_PROGRESS, classes: {
                    root: styles_modules_less_1.default.processStatus,
                    container: styles_modules_less_1.default.progress,
                } }),
            react_1.default.createElement(react_2.default, { content: stageTooltips.stageStatus, placement: 'top' },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.statusSummary, !isEdit && styles_modules_less_1.default.reviewFieldDetail, !isEdit && styles_modules_less_1.default.statusSummaryDetail) },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)([
                            (0, helper_1.getProgressIcon)(reviewStage.status),
                            styles_modules_less_1.default.statusIcon,
                            reviewStage.status !== review_stages_1.STAGE_STATUS.completed &&
                                styles_modules_less_1.default.clockIcon,
                        ]) }),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default.statusName }, reviewStage.decisionStatusLabel || reviewStage.statusLabel))),
            react_1.default.createElement(react_2.default, { content: stageTooltips.stageTrigger, placement: 'top' },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.triggerType, !isEdit && styles_modules_less_1.default.reviewFieldDetail) },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)('fa-light fa-bolt', styles_modules_less_1.default.triggerTypeIcon) }),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default.triggerTypeName }, stageTriggerTypeName))),
            !isEdit && (react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.stagePlayButton, !showPlayButton && styles_modules_less_1.default['stage-play-button--disable']), onClick: (e) => handleTriggerStageManually(e) },
                react_1.default.createElement(react_2.default, { content: stageTooltips.startStage, placement: 'top' },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)('fa-light fa-circle-play', styles_modules_less_1.default.stagePlayButtonIcon) })))),
            react_1.default.createElement(react_2.default, { content: stageTooltips.stageDecisionRule, placement: 'top' },
                react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default.stageDecisionName, !isEdit && styles_modules_less_1.default.reviewFieldDetail) },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)('fa-light fa-user-check', styles_modules_less_1.default.stageDecisionNameIcon) }),
                    react_1.default.createElement("span", { className: styles_modules_less_1.default.stageDecisionNameLabel }, getStageDecisionName))),
            react_1.default.createElement(react_2.default, { content: getTooltipDueDate, placement: 'top' },
                react_1.default.createElement("span", { className: styles_modules_less_1.default.dueDate, style: { color: deadlineColor } },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)('fa-light fa-calendar', styles_modules_less_1.default.dueDateIcon) }))),
            ' ',
            isEdit && isShowTriggerStageButton && (react_1.default.createElement(react_2.default, { content: stageTooltips.stageCog, placement: 'top' },
                react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-gear', styles_modules_less_1.default.gearIcon), onClick: (e) => {
                        e.stopPropagation();
                        setTriggerStateModal === null || setTriggerStateModal === void 0 ? void 0 : setTriggerStateModal(() => ({
                            index: stageIndex,
                            isOpen: true,
                        }));
                    } }))),
            react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-trash-alt', 'removeIcon', {
                    'removeIcon--hide': !(0, isFunction_1.default)(handleRemoveStage) ||
                        reviewStage.status === review_stages_1.STAGE_STATUS.inProgress,
                }), onClick: (e) => (0, isFunction_1.default)(handleRemoveStage) &&
                    handleClickRemove(e, reviewStage.id ? reviewStage.id : 0) })),
        children));
};
exports.default = AccordionReviewStage;
